var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.793 1.33325H5.20634C2.77967 1.33325 1.33301 2.77992 1.33301 5.20658V10.7866C1.33301 13.2199 2.77967 14.6666 5.20634 14.6666H10.7863C13.213 14.6666 14.6597 13.2199 14.6597 10.7933V5.20658C14.6663 2.77992 13.2197 1.33325 10.793 1.33325ZM11.1863 6.46658L7.40634 10.2466C7.31301 10.3399 7.18634 10.3933 7.05301 10.3933C6.91967 10.3933 6.79301 10.3399 6.69967 10.2466L4.81301 8.35992C4.61967 8.16658 4.61967 7.84658 4.81301 7.65325C5.00634 7.45992 5.32634 7.45992 5.51967 7.65325L7.05301 9.18658L10.4797 5.75992C10.673 5.56659 10.993 5.56659 11.1863 5.75992C11.3797 5.95325 11.3797 6.26658 11.1863 6.46658Z",
    fill: "#65A30D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteUpload);
export default __webpack_public_path__ + "static/media/CompleteUpload.c880ba4415b585e619dbf373bec28c31.svg";
export { ForwardRef as ReactComponent };